const useStarFilledStatus = (ratingValue: number, index: number, hover: number) => {
    const rating = Number(ratingValue.toFixed(2));
    const reminderValue = rating % 1;
    const integerValue = rating - reminderValue;

    let filledPart = 0;

    if (index <= (hover || integerValue)) {
        filledPart = 100;
    } else if (!hover && reminderValue && index === integerValue + 1) {
        filledPart = Number((reminderValue * 100).toFixed(0));

        // Star's filling rules:
        // 4.0 - 4.2 => 4.0
        // 4.3 - 4.7 => 4.5
        // 4.8 - 5.0 => 5.0
        if (filledPart < 30) {
            filledPart = 0;
        } else if (filledPart < 80) {
            filledPart = 50;
        } else {
            filledPart = 100;
        }
    }

    return { filledPart };
};

export default useStarFilledStatus;
